import { UseScriptResult, useScript } from './useScript';

export function useGoogleIdentityServices(): UseScriptResult {
  return useScript('https://accounts.google.com/gsi/client');
}
